// ThemeContext.jsx
import React, { createContext, useState, useContext, useEffect } from "react";
import { themes } from "./../config/themes"; // Assuming themes.js exports the themes object

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Get theme from localStorage or default to minimal
    const savedThemeName = localStorage.getItem("selectedTheme");
    if (!savedThemeName) {
      return themes.minimal;
    }

    const matchedThemeKey = Object.keys(themes).find(
      (key) => themes[key].name === savedThemeName,
    );

    return matchedThemeKey ? themes[matchedThemeKey] : themes.minimal;
  });

  // Update localStorage whenever theme changes
  useEffect(() => {
    localStorage.setItem("selectedTheme", theme.name);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
